const NikeDATA = [
    {
        id : 0,
        title : "Nike Mercurial Vapor 13",
        price : 59.99,
        desc : "Nike Jr. Mercurial Vapor 13 Firm-Ground Football Boot",
        img : "/assets/images/products/Nike/Nike_Jr_Mercurial_Vapor_13.jpeg",
        img2 : "/assets/images/products/Nike/img2/Nike_Jr_Mercurial_Vapor_13.jpeg",
        img3 : "/assets/images/products/Nike/img3/Nike_Jr_Mercurial_Vapor_13.jpeg",
        img4 : "/assets/images/products/Nike/img4/Nike_Jr_Mercurial_Vapor_13.jpeg",
        img5 : "/assets/images/products/Nike/img5/Nike_Jr_Mercurial_Vapor_13.jpeg"
    },
    {
        id : 1,
        title : "Nike Neymar Vapor 12",
        price : 84.99,
        desc : "Nike Neymar Vapor 12 Firm-Ground Football Boot",
        img : "/assets/images/products/Nike/Nike_Neymar_Vapor_12.jpeg",
        img2 : "/assets/images/products/Nike/img2/Nike_Neymar_Vapor_12.jpeg",
        img3 : "/assets/images/products/Nike/img3/Nike_Neymar_Vapor_12.jpeg",
        img4 : "/assets/images/products/Nike/img4/Nike_Neymar_Vapor_12.jpeg",
        img5 : "/assets/images/products/Nike/img5/Nike_Neymar_Vapor_12.jpeg"
    },
    {
        id : 2,
        title : "Nike Vapor 12 Pro",
        price : 119.99,
        desc : "Nike Vapor 12 Pro Firm-Ground Football Boot",
        img : "/assets/images/products/Nike/Nike_Vapor_12_Pro.jpeg",
        img2 : "/assets/images/products/Nike/img2/Nike_Vapor_12_Pro.jpeg",
        img3 : "/assets/images/products/Nike/img3/Nike_Vapor_12_Pro.jpeg",
        img4 : "/assets/images/products/Nike/img4/Nike_Vapor_12_Pro.jpeg",
        img5 : "/assets/images/products/Nike/img5/Nike_Vapor_12_Pro.jpeg"
    },
    {
        id : 3,
        title : "Nike Vapor 12 Elite",
        price : 249.99,
        desc : "Nike Vapor 12 Elite Firm-Ground Football Boot",
        img : "/assets/images/products/Nike/Nike_Vapor_12_Elite.jpeg",
        img2 : "/assets/images/products/Nike/img2/Nike_Vapor_12_Elite.jpeg",
        img3 : "/assets/images/products/Nike/img3/Nike_Vapor_12_Elite.jpeg",
        img4 : "/assets/images/products/Nike/img4/Nike_Vapor_12_Elite.jpeg",
        img5 : "/assets/images/products/Nike/img5/Nike_Vapor_12_Elite.jpeg"
    },
    {
        id : 4,
        title : "Nike Mercurial Victory VI Dynamic Fit",
        price : 89.99,
        desc : "Nike Mercurial Victory VI Firm-Ground Football Boot",
        img : "/assets/images/products/Nike/Nike_Mercurial_Victory_VI.jpeg",
        img2 : "/assets/images/products/Nike/img2/Nike_Mercurial_Victory_VI.jpeg",
        img3 : "/assets/images/products/Nike/img3/Nike_Mercurial_Victory_VI.jpeg",
        img4 : "/assets/images/products/Nike/img4/Nike_Mercurial_Victory_VI.jpeg",
        img5 : "/assets/images/products/Nike/img5/Nike_Mercurial_Victory_VI.jpeg"
    },
    {
        id : 5,
        title : "Nike CR7 Superfly 6 MG Multi-Ground",
        price : 94.99,
        desc : "Firm-Ground Football Boot",
        img : "/assets/images/products/Nike/Nike_CR7_Superfly_6.jpeg",
        img2 : "/assets/images/products/Nike/img2/Nike_CR7_Superfly_6.jpeg",
        img3 : "/assets/images/products/Nike/img3/Nike_CR7_Superfly_6.jpeg",
        img4 : "/assets/images/products/Nike/img4/Nike_CR7_Superfly_6.jpeg",
        img5 : "/assets/images/products/Nike/img5/Nike_CR7_Superfly_6.jpeg"
    },
    {
        id : 6,
        title : "Nike Mercurial Vapor 13 Elite Tech",
        price : 249.99,
        desc : "Firm-Ground Football Boot",
        img : "/assets/images/products/Nike/Nike_Mercurial_Vapor_13.jpeg",
        img2 : "/assets/images/products/Nike/img2/Nike_Mercurial_Vapor_13.jpeg",
        img3 : "/assets/images/products/Nike/img3/Nike_Mercurial_Vapor_13.jpeg",
        img4 : "/assets/images/products/Nike/img4/Nike_Mercurial_Vapor_13.jpeg",
        img5 : "/assets/images/products/Nike/img5/Nike_Mercurial_Vapor_13.jpeg"
    },
    {
        id : 7,
        title : "Nike Mercurial Superfly 7 Elite",
        price : 274.99,
        desc : "Nike Mercurial Superfly 7 Elite Firm-Ground Football Boot",
        img : "/assets/images/products/Nike/Nike_Mercurial_Superfly_7_Elite.jpeg",
        img2 : "/assets/images/products/Nike/img2/Nike_Mercurial_Superfly_7_Elite.jpeg",
        img3 : "/assets/images/products/Nike/img3/Nike_Mercurial_Superfly_7_Elite.jpeg",
        img4 : "/assets/images/products/Nike/img4/Nike_Mercurial_Superfly_7_Elite.jpeg",
        img5 : "/assets/images/products/Nike/img5/Nike_Mercurial_Superfly_7_Elite.jpeg"
    },
]
export default NikeDATA;